// @flow

import { type Amount, type Decimal } from '../types';

export function getValue(amount: Amount): Decimal {
  return amount[1];
}
